import React from 'react';
import Spinner from '@shape-construction/arch-ui/src/Spinner';

type PageSaveLoadingProps = {
  isSaving: boolean;
  savingMessage: string;
  savedMessage: string;
};

export const PageSaveLoading: React.FC<PageSaveLoadingProps> = ({ isSaving, savingMessage, savedMessage }) => (
  <div className="flex gap-x-2 items-center p-2">
    {isSaving && <Spinner role="progressbar" size="sm" className="stroke-black" />}
    <span className="text-gray-400 text-xs leading-4 font-medium">{isSaving ? savingMessage : savedMessage}</span>
  </div>
);
